var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-loader w-full h-screen flex justify-center items-center"},[_c('div',{staticClass:"lds-ring",class:_vm.spinnerSize},[_c('div',{class:_vm.borderSpinnerColor}),_c('div',{class:_vm.borderSpinnerColor}),_c('div',{class:_vm.borderSpinnerColor}),_c('div',{class:_vm.borderSpinnerColor})])])
}
var staticRenderFns = []

export { render, staticRenderFns }